import styled from "styled-components";
import { colors } from "../../utils/theme";
import { useLoyaltyUser } from "../hooks/firestore/useLoyaltyUser";

// Current Smulpunten balance, shown next to the menu item. Renders nothing for guests.
export default function LoyaltyPointsBadge() {
  const { data: loyaltyUser } = useLoyaltyUser();

  if (!loyaltyUser) return null;

  return <Badge>{loyaltyUser.currentPoints}</Badge>;
}

const Badge = styled.span`
  padding: 0 8px;
  border-radius: 1000vw;
  background-color: ${colors.loyalty_primary};
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
`;
